export const GET_REVENUE_LIST = 'GET_REVENUE_LIST';
export const GET_REVENUE_LIST_SUCCESS = 'GET_REVENUE_LIST_SUCCESS';
export const GET_REVENUE_LIST_FAILED = 'GET_REVENUE_LIST_FAILED';

export const EXPORT_REVENUE_LIST = 'EXPORT_REVENUE_LIST';
export const EXPORT_REVENUE_LIST_SUCCESS = 'EXPORT_REVENUE_LIST_SUCCESS';
export const EXPORT_REVENUE_LIST_FAILED = 'EXPORT_REVENUE_LIST_FAILED';
